import { isMockMode, postBlast, simulateDelay } from "../../api";

export interface UpdateNodeLibrarySitesRequest {
	id: string;
	siteIds: string[];
	isDeleted?: boolean;
	hasWriteAccess?: boolean;
}

export const updateNodeLibrarySites = ({
	id,
	siteIds,
	isDeleted = false,
	hasWriteAccess = false,
}: UpdateNodeLibrarySitesRequest) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`nodelibrary/updatesites`, {
		id,
		siteIds,
		isDeleted,
		hasWriteAccess,
	});
};
